import { TrendingUp, PhoneCall, Ban } from "lucide-react";

const items = [
  {
    icon: TrendingUp,
    title: "Unrealistische Renditeversprechen",
    text: "Werben Anbieter mit 1% Gewinn pro Tag oder absolutem Risikoausschluss, handelt es sich fast immer um ein Schneeballsystem.",
  },
  {
    icon: PhoneCall,
    title: "Aggressives Telefonmarketing",
    text: "Sogenannte „Boiler Rooms“ setzen Sie psychologisch unter Druck, sofort mehr Geld zu überweisen, um angebliche Chancen nicht zu verpassen.",
  },
  {
    icon: Ban,
    title: "Auszahlungsverweigerung",
    text: "Sobald Sie Kapital abheben möchten, werden plötzlich „Steuern“, „Liquiditätsgebühren“ oder „Versicherungen“ fällig.",
  },
];

export function WarningSigns() {
  return (
    <section className="bg-secondary/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Woran man Anlagebetrug erkennt
          </h2>
          <p className="mt-3 text-muted-foreground">
            Früherkennung ist der beste Schutz. Achten Sie auf diese klassischen
            Warnsignale bei Online-Investitionen.
          </p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {items.map((it) => (
            <div
              key={it.title}
              className="rounded-xl border border-border bg-card p-6 shadow-[var(--shadow-card)] transition-all hover:-translate-y-1 hover:shadow-[var(--shadow-elegant)]"
            >
              <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-secondary text-navy">
                <it.icon className="h-5 w-5" />
              </div>
              <h3 className="text-lg font-semibold">{it.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}